import * as types from '../mutation-types';

const state = {
  bidSectionObj: {},
  bidSectionInfosArr: [],
  bidDissentObj: {},
  bidDissentInfosArr: {},
  bidSectionIndex: 0,
  updatePubBidderState: false,
};

const getters = {
  getBidSection: (state) => state.bidSectionObj,
  getBidSectionInfos: (state) => state.bidSectionInfosArr,
  getDissentObj: (state) => state.bidDissentObj,
  getDissentInfosArr: (state) => state.bidDissentInfosArr,
  getPubBidderState: (state) => state.updatePubBidderState,
};

const actions = {
  // 记录刷新公布投标人状态
  async setUpdatePubBidder({ commit }, obj) {
    commit(types.GET_UPDATEPUBBIDDER_STATUS, obj);
  },
  // 点击标段切换
  async setBidSection({ commit }, obj) {
    commit(types.GET_BIDSECTION_STATUS, obj);
  },
  // 标段切换下标
  async setBidIndex({ commit }, obj) {
    commit(types.GET_BIDINDEX_STATUS, obj);
  },
  // 项目下的所有标段信息
  async setBidSectionInfos({ commit }, obj) {
    commit(types.GET_BIDSECTION_STATUS_INFOS, obj);
  },

  async setDissentObj({ commit }, obj) {
    commit(types.GET_DISSENTSECTION_STATUS, obj);
  },

  async setDissentInfosArr({ commit }, obj) {
    commit(types.GET_DISSENTSECTION_STATUS_INFOS, obj);
  },
};

const mutations = {
  [types.GET_BIDSECTION_STATUS](state, obj) {
    state.bidSectionObj = obj;
  },
  [types.GET_BIDSECTION_STATUS_INFOS](state, obj) {
    state.bidSectionInfosArr = obj;
  },
  [types.GET_DISSENTSECTION_STATUS](state, obj) {
    state.bidDissentObj = obj;
  },
  [types.GET_DISSENTSECTION_STATUS_INFOS](state, obj) {
    state.bidDissentInfosArr = obj;
  },
  [types.GET_BIDINDEX_STATUS](state, obj) {
    state.bidSectionIndex = obj;
  },
  [types.GET_UPDATEPUBBIDDER_STATUS](state, obj) {
    state.updatePubBidderState = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
